import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickProbeDataset from '@/components/brick_probe_dataset.vue'
import SummaryResult from '@/components/summary_result.vue'
import Vue from 'vue'

Vue.component('SummaryResult', SummaryResult)

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-rectangle-portrait', 'text-green']
infos.front_classes = ['fas', 'fa-thermometer-half', 'text-white']
// infos.front_classes = ['fas', 'fa-temperature-low', 'text-white']
// infos.front_classes = []
infos.name = 'probedataset'
infos.associated_class_name = 'AutomlProbeDataset'
infos.editing_component_name = 'BricProbeDataset'
infos.editing_component = BrickProbeDataset
infos.summary_component_name = 'SummaryResult'
infos.summary_component = SummaryResult
infos.descriptions = {
	en: {
		short_tooltip_description: 'Probes a dataset',
		full_tooltip_description: 'Probes a dataset',
		navbar_name: 'Dataset probe',
	},
	fr: {
		short_tooltip_description: 'Sonde de jeu de données',
		full_tooltip_description: 'Sonde de jeu de données',
		navbar_name: 'Sonde de jeu de données',
	},
}

infos.background_color = 'green'

brick_registerer(infos)
